export type TaskDateFilter = 'past' | 'today' | 'future';

export const DEFAULT_TASK_DATE_FILTERS: TaskDateFilter[] = ['today'];
export const ALL_TASK_DATE_FILTERS: TaskDateFilter[] = ['past', 'today', 'future'];

/**
 * Utility class for task filtering and date operations
 */
export class TaskFilterUtils {

    /**
     * Check if a specific date filter is selected
     * @param selectedDates - Array of selected date filters
     * @param dateFilter - The date filter to check
     * @returns True if the date filter is selected
     */
    static hasDateFilter(selectedDates: TaskDateFilter[], dateFilter: TaskDateFilter): boolean {
        return selectedDates.includes(dateFilter);
    }

    /**
     * Toggle a date filter in the selection
     * @param selectedDates - Current array of selected date filters
     * @param dateFilter - The date filter to toggle
     * @param allowEmpty - Whether to allow no dates to be selected (default: false)
     * @returns New array of selected date filters
     */
    static toggleDateFilter(
        selectedDates: TaskDateFilter[],
        dateFilter: TaskDateFilter,
        allowEmpty = false
    ): TaskDateFilter[] {
        if (this.hasDateFilter(selectedDates, dateFilter)) {
            if (selectedDates.length === 1 && !allowEmpty) {
                return selectedDates;
            }
            return selectedDates.filter(d => d !== dateFilter);
        } else {
            return [...selectedDates, dateFilter];
        }
    }

    /**
     * Get the initial state for task date filters
     * @returns Default selected date filters
     */
    static getInitialDateFilters(): TaskDateFilter[] {
        return [...DEFAULT_TASK_DATE_FILTERS];
    }
}
